import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import React from "react";

/**
 * @name CustomContentHeaderWidget
 * @returns {React.Component}
 * @description The component that contains all the content shown for the CustomContentHeaderWidget
 */
export default function CustomContentHeaderWidget(props){
  var scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  var onClick = function(evt){
      if(evt.target.attributes){
          if(evt.target.attributes.disabled){
          if(evt.target.attributes.disabled.value =="true"){
              document.getElementsByClassName("subheaderDisablePrompt")[0].click()
          }
      }
      }
  }
     // Remove all <script> tags from the string
    let content =  props.content.replace(scriptRegex, '');
  const markup = { __html: content };
  return (<><div dangerouslySetInnerHTML={markup} className="custom-content-header-widget" onClick = {onClick}/> <DisabledPrompt ><span className="subheaderDisablePrompt"></span></DisabledPrompt></>);
}